/*
 * Activates the modal gallery on certain templates
 *
 * @author BarrelNY
 *
 */
var Gallery = {
	init:function(){
		//What templates should trigger this module?
		var templates = [
			'body.U1-template',
			'body.U2-template',
			'body.neighborhood-template',
			'body.progress-page'
		].join();

		if (!$(templates).length) return;

		this.template = $('#gallery-template').text();

		this.$ajaxCon = $('#ajax-content-container');

		this.$buttons = $('[data-gallery-trigger]');
		this.$images  = $('[data-gallery]').getImages();

		this.modal = '.galleryModal';

		this.animating = false;

		this.events();
	},

	/*
	 * Called in two different ways:
	 * On init (!delayed) and after the modal
	 * window has been added to the DOM (delayed)
	 *
	 * @param boolean delayed  which events to init
	 *
	 */
	events:function( delayed ){
		var self = this;

		if (typeof delayed == 'undefined' || !delayed ){
			this.$buttons.click( this.show.bind(this) );
		} else {
			$(this.modal)
				.on('click','.arrow-right', this.next.bind(this) )
				.on('click','.arrow-left',  this.prev.bind(this) )
				.on('click','.icon-close',  this.hide.bind(this) );

			if (Hammer){

				var H = new Hammer( $('.inner',this.modal)[0] ).on(
					'swipe',function(obj){
						var dir = ( obj.deltaX < 0 ? 'next' : 'prev');
						self[dir].call(self);
					}
				);

			}

		}
	},

	/*
	 * The modal show and modal hide GSAP animation
	 * with the ability to be reversable (note the
	 * 0 duration fromTo animation)
	 *
	 * @param string dir  the direction we want to go (forward|back)
	 *
	 */
	animation:function(dir){
		var
			_ = this,
			$inner = $(this.modal).find('.inner'),
			$icons = $(this.modal).find('.icon');

		var t = new TimelineMax(
			{
				onReverseComplete:function(){
					if ( !$('body').hasClass('U1-template') || MUR.isSmall() )
						$('body').css('overflow','auto');

					$(_.modal).remove();
				}
			}
		)
		.set('body', {overflow:'hidden'})
		.fromTo($inner, 0, {scale:1,opacity:1}, {scale:0.95,opacity:0})
		.fromTo($icons, 0, {opacity:1,y:0}, {opacity:0,y:-10})
		.fromTo(this.modal, 0, {display:'none'}, {display:'block'})
		.fromTo(this.modal, 1.5, {opacity:0}, {opacity:1})
		.to($inner, 1, {opacity:1,scale:1},'-=0.5')
		.staggerTo($icons, 1, {opacity:0.9,y:0, clearProps:"all"},0.3,'-=1.5')
		.pause();

		if ( dir == 'forward' ){
			t.play(0);
		} else {
			t.timeScale(2).reverse(0);
		}
	},

	/*
	 * Get the first image and render the modal window
	 * html to the DOM (saved in a text/template script tag)
	 *
	 * @see footer.php
	 * @param object e event object
	 *
	 */
	show:function(e){
		var
			$gallery = $(this.modal),
			img      = e.currentTarget.parentNode.galleryImage;

		// Progress gallery buttons link to first image in post
		if ( !img ){
			img = e.currentTarget.children[0].galleryImage;
		}

		if ( !img ){
			var el = this.$images.first();
			img = el[0].galleryImage;
		}

		this.currentImage = img;

		if ( $gallery.length ) $gallery.remove();

		this.$ajaxCon.prepend( this.template.replace('{{gallery-url}}',img) );

		this.animation('forward');

		//isDelayed? Reason for true
		this.events(true);

		return false;
	},

	/*
	 * Compare the current image string to the image
	 * strings associated which each button to pick out
	 * the current slide (slides are actually the
	 * button DOM elements that have images)
	 *
	 * @returns int  the index of the active 'slide'
	 *
	 */
	findIndex:function(){
		var
			currentEl = false,
			currentImage = this.currentImage,
			matchFound = false;

		this.$images.each(function(){
			if ( this.galleryImage == currentImage ){
				if (!currentEl){
					matchFound = true;
					currentEl = this;
				}
			}
		});

		return this.$images.index(currentEl);
	},

	/*
	 * Kill the modal by reversing the animation
	 * Note: The reverse callback removes the modal
	 * DOM element and children from the DOM
	 *
	 */
	hide:function(){
		this.animation('reverse');
	},

	/*
	 * Gets the current index,
	 * increment up 1 (or start from the beginning)
	 * and get the next image string to give to the
	 * transition function
	 *
	 */
	next:function(){
		if ( this.animating )
			return;

		var
			i = this.findIndex() + 1,
			img = this.returnImage('next',i);

		this.transition('next',img);
	},

	/*
	 * Gets the current index,
	 * increment down 1 (or start from the end)
	 * and get the next image string to give to the
	 * transition function
	 *
	 */
	prev:function(){
		if ( this.animating )
			return;

		var
			i = this.findIndex() - 1,
			img = this.returnImage('prev',i);

		this.transition('prev',img);
	},

	/*
	 * Decides to either return the next image or if
	 * we need to, get the first or last image and thus
	 * provide looping functionality
	 *
	 * @param string dir  the direction we want to go
	 * @param int i  the index of the next slide
	 * @returns string  the next image string
	 *
	 */
	returnImage:function(dir,i){
		if ( this.$images.eq(i).length ){
			return this.currentImage = this.$images.eq(i)[0].galleryImage;
		} else {
			var tip = dir == 'next' ? 0 : this.$images.length-1;
			return this.currentImage = this.$images.eq(tip)[0].galleryImage;
		}
	},

	/*
	 * Creates a new slide DOM element and executes
	 * the transition from old image to new image.
	 * removes the old image HTML after the animation
	 *
	 * @param string dir  the direction we want to go
	 * @param string img  the next image string
	 *
	 */
	transition:function(dir,img){
		var
			_ = this,
			$old = $('.gallery-image').eq(0)
			$new = $old.clone();

		$new.css({
			display:'none',
			backgroundImage:'url('+img+')'
		});

		$new.insertAfter( $old );

		var
			x = dir == 'next' ? 30 : -30,
			x2 = dir == 'next' ? -30 : 30;

		this.animating = true;

		new TimelineMax(
			{
				onComplete:function(){
					$old.remove();
					_.animating = false;
				}
			}
		)
		.set( $new, {x:x,opacity:0,display:'block'} )
		.set( $old, {x:0,opacity:1} )
		.to( $new, 1, {x:0,opacity:1} )
		.to( $old, 1, {x:x2,opacity:0}, '-=1' );
	},

	/*
	 * Rebuilds button and image vars and event handlers
	 * Used after AJAX post loading
	 *
	 */
	rebuild:function(){
		this.$buttons = $('[data-gallery-trigger]');
		this.$images  = $('[data-gallery]').getImages();
		this.$buttons.click( this.show.bind(this) );
	},

	/*
	 * Prep for re-init
	 * @param	void
	 * @returns void
	 */
	drop:function(){}
}

/*
 * jQuery plugin
 *
 * Runs through the given (by context) jQuery
 * array and gives each DOM node a new property
 * 'galleryImage' with the src of a the connected
 * image.
 *
 * @returns jQuery obj for chaining purposes
 *
 */
$.fn.getImages = function(){
	var i = 1;

	this.each(function(){
		var
			$img = $(this),
			src  = false;

		if ($img.length != 1)
			return;

		if ( $img[0].nodeName != 'DIV' )
			return;

		if ( $img.attr('data-delay-src') ){
			src = $img.attr('data-delay-src')
		} else if( $img.attr('data-src') ){
			src = $img.attr('data-src')
		} else {
			var style = $img.attr('style').match(/url[(']{2}(.*)[)']{2}/);

			if ( style && style.length >= 2 ) src = style[1];
		}

		this.galleryImage = src;
	});

	return this;
}

module.exports = Gallery;
